import IPremiumFee from './IPremiumFee';
import { eTransactionCategory } from '../../ui-toolkit/enums/eTransactionType';
import { IAddressData } from '../../ui-toolkit/orders/interfaces/IAddressResponse';

export interface IPolicyOrderDetails {
  county: string | null;
  closingDate: string | null;
  fileNumber: string | null;
  insuredMortgage: string | null;
  transactionCategory: eTransactionCategory | null;
  loanNumber: string | null;
  legalDescription: string | null;
  liabilityAmount: number | null;
  mortgageeClause: string | null;
  nameOfInsured: string | null;
  borrowers: string | null;
  vestedIn: string | null;
  premiums: IPremiumFee[] | null;
  cplFee: number | null;
  propertyAddress: IAddressData | null;
  endorsements: string[];
}

export const constructNewPolicyOrderDetails = ({
  county = null,
  closingDate = null,
  fileNumber = null,
  insuredMortgage = null,
  transactionCategory = null,
  legalDescription = null,
  loanNumber = null,
  liabilityAmount = null,
  mortgageeClause = null,
  nameOfInsured = null,
  borrowers = null,
  premiums = null,
  cplFee = null,
  propertyAddress = null,
  vestedIn = null,
  endorsements = [],
}: Partial<IPolicyOrderDetails> = {}) => ({
  county,
  closingDate,
  endorsements,
  fileNumber,
  insuredMortgage,
  transactionCategory,
  legalDescription,
  loanNumber,
  liabilityAmount,
  mortgageeClause,
  nameOfInsured,
  borrowers,
  premiums,
  cplFee,
  propertyAddress,
  vestedIn,
});
